import React, { useContext, useEffect } from 'react';

import { ViewTextPageProps } from './types';
import { ContentStyled, RootStyled } from './styles';
import { CustomEditorV2Readonly } from '@/component/customEditorV2';
import { CourseNavigationContext } from '@/administration/pages/Course/MainLayoutView/atoms/NavigationActions/CourseNavigationProvider';

export const ViewTextPage = ({ id, text, spaceId, onCompleted }: ViewTextPageProps): JSX.Element => {
  const { forceNavigationUpdateRef, hasReachedEndRef } = useContext(CourseNavigationContext);

  const handleEditorLoaded = () => {
    !!forceNavigationUpdateRef?.current && forceNavigationUpdateRef.current();
  };

  // A Page reports completion on unmount, but only if the learner actually reached its end.
  // Reset the shared flag on mount, then complete on unmount only when the navigation has
  // set it again (the page was scrolled to the bottom, or it fits on the screen and has
  // nothing to scroll) — leaving a long page unread must not grant progress. See PT-5785.
  useEffect(() => {
    if (hasReachedEndRef) {
      hasReachedEndRef.current = false;
    }

    return () => {
      if (onCompleted && hasReachedEndRef?.current) {
        onCompleted();
      }
    };
  }, []);

  return (
    <RootStyled key={id}>
      <ContentStyled>
        <CustomEditorV2Readonly
          value={text}
          style={{ fontSize: 14 }}
          $fullSize
          minimized
          spaceId={spaceId}
          onLoad={handleEditorLoaded}
        />
      </ContentStyled>
    </RootStyled>
  );
};
